import { inputDescLimit, inputTextLimit } from '../../../../helpers/fieldRestriction';
import messages from '../../../../locale/jsonMessages';

const validate = (values, props) => {
  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (!values.dynamicWhyHostInfoBlock || values.dynamicWhyHostInfoBlock.length === 0) {

    if (!values.hostBannerTitle1 || values.hostBannerTitle1.trim() === '') {
      errors.hostBannerTitle1 = messages.required;
    } else if (values.hostBannerTitle1.length > inputTextLimit) {
      errors.hostBannerTitle1 = messages.inputTextLimitError;
    }

    if (!values.hostBannerContent1 || values.hostBannerContent1.trim() === '') {
      errors.hostBannerContent1 = messages.required;
    } else if (values.hostBannerContent1.length > inputDescLimit) {
      errors.hostBannerContent1 = messages.inputDescLimitError;
    }

    if (!values.hostBannerContent2 || values.hostBannerContent2.trim() === '') {
      errors.hostBannerContent2 = messages.required;
    } else if (values.hostBannerContent2.length > inputTextLimit) {
      errors.hostBannerContent2 = messages.inputTextLimitError;
    }

    if (!values.buttonLabel || values.buttonLabel.trim() === '') {
      errors.buttonLabel = messages.required;
    } else if (values.buttonLabel.length > inputTextLimit) {
      errors.buttonLabel = messages.inputTextLimitError;
    }

    if (!values.buttonLabel2 || values.buttonLabel2.trim() === '') {
      errors.buttonLabel2 = messages.required;
    } else if (values.buttonLabel2.length > inputTextLimit) {
      errors.buttonLabel2 = messages.inputTextLimitError;
    }

    return errors;
  }

  const dynamicErrors = values.dynamicWhyHostInfoBlock.map((item = {}) => {
    const itemErrors = {};

    const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
      && !activeLanguageCodes.includes(item.language);

    if (!item.language || item.language.toString().trim() === '' || isLanguageInactive) {
      itemErrors.language = messages.required;
    }

    if (!item.hostBannerTitle1 || item.hostBannerTitle1.trim() === '') {
      itemErrors.hostBannerTitle1 = messages.required;
    } else if (item.hostBannerTitle1.length > inputTextLimit) {
      itemErrors.hostBannerTitle1 = messages.inputTextLimitError;
    }

    if (!item.hostBannerContent1 || item.hostBannerContent1.trim() === '') {
      itemErrors.hostBannerContent1 = messages.required;
    } else if (item.hostBannerContent1.length > inputDescLimit) {
      itemErrors.hostBannerContent1 = messages.inputDescLimitError;
    }

    if (!item.hostBannerContent2 || item.hostBannerContent2.trim() === '') {
      itemErrors.hostBannerContent2 = messages.required;
    } else if (item.hostBannerContent2.length > inputTextLimit) {
      itemErrors.hostBannerContent2 = messages.inputTextLimitError;
    }

    if (!item.buttonLabel || item.buttonLabel.trim() === '') {
      itemErrors.buttonLabel = messages.required;
    } else if (item.buttonLabel.length > inputTextLimit) {
      itemErrors.buttonLabel = messages.inputTextLimitError;
    }

    if (!item.buttonLabel2 || item.buttonLabel2.trim() === '') {
      itemErrors.buttonLabel2 = messages.required;
    } else if (item.buttonLabel2.length > inputTextLimit) {
      itemErrors.buttonLabel2 = messages.inputTextLimitError;
    }

    return itemErrors;
  });

  if (dynamicErrors.some(item => Object.keys(item).length > 0)) {
    errors.dynamicWhyHostInfoBlock = dynamicErrors;
  }

  return errors;
};

export default validate;